import type { ResolvedMonospaceApiKey, ResolvedMonospaceServiceAccount, ResolvedMonospaceUser } from '#layers/data-model/public';
import { useOverlay } from '@nuxt/ui/composables';
import ApiKeyDialog from '#layers/access/components/ApiKeys/ApiKeyDialog.vue';

interface UseApiKeyDialogsOptions {
	onCreateServiceAccount?: () => unknown;
}

export function useApiKeyDialogs(options: UseApiKeyDialogsOptions = {}) {
	const overlay = useOverlay();

	async function createApiKey(user?: ResolvedMonospaceServiceAccount | ResolvedMonospaceUser) {
		const modal = overlay.create(ApiKeyDialog, {
			props: {
				userId: user?.id ?? null,
				onCreateServiceAccount: options.onCreateServiceAccount,
			},
		});

		return await modal.open().result;
	}

	async function editApiKey(apiKey: ResolvedMonospaceApiKey) {
		const modal = overlay.create(ApiKeyDialog, {
			props: {
				userId: apiKey.user?.id ?? null,
				apiKey,
				onCreateServiceAccount: options.onCreateServiceAccount,
			},
		});

		return await modal.open().result;
	}

	return { createApiKey, editApiKey };
}
